export const isLoggedIn = localStorage.getItem('isLoggedIn') ? true : false;